export const isJsonString = (str: unknown): boolean => {
  try {
    JSON.parse(str as string);
  } catch (e) {
    return false;
  }
  return true;
};

export const safeJsonParse = (value?: string, defaultValue = {}): unknown => {
  if (!value) {
    return defaultValue;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return defaultValue;
  }
};

export const safeJsonStringify = (
  value?: Record<string, unknown> | Array<unknown>,
  defaultValue = ''
): string => {
  if (!value) {
    return defaultValue;
  }

  try {
    return JSON.stringify(value);
  } catch (e) {
    return defaultValue;
  }
};
